/**
 * Created by jomsm on 26/07/2017.
 */
(function () {

    'use strict';

    angular.module('Services').factory('CarrierSettingsTableService', CarrierSettingsTableService);

    CarrierSettingsTableService.$inject = [
        '$uibModal',
        '$timeout',
    ];

    function CarrierSettingsTableService(
        $uibModal,
        $timeout
    ) {
        return function (profileSettings) {
            let vm = this;
            vm.isInvalid = true;
            vm.isValid = false;

            const typeOptions = ['Boolean', 'Text', 'Number'];
            const requiredLabel = '<span class="text-red">*</span>';

            let settingsTable = {
                config: {
                    noPagination: true,
                    noHeaders: false,
                    noItemsView: true,
                    noFooter: true,
                    noExtraction: true
                },
                /*optionAddOns: {
                    buttons: [{
                        class: 'btn-primary',
                        label: 'Configure settings',
                        onClick: openConfigureTable
                    }]
                },*/
                headers: [{
                    label: 'SETTING',
                    viewName: 'name',
                    width: '20%'
                }, {
                    label: 'DESCRIPTION',
                    viewName: 'description',
                    width: '40%'
                }, {
                    label: 'VALUE',
                    viewName: 'valueObj',
                    width: '20%'
                }],
                data: []
            };

            function getType(type, value, options, row) {
                // construct the tooltip for switcher
                let tooltip = null;
                if(options){
                    tooltip = 'Click to switch ' + options.true.toLowerCase() + ' / ' + options.false.toLowerCase();
                }
                if (type.toLowerCase() === 'text') {
                    return {
                        type: 'textInput',
                        options: {
                            isRequired: row.isMandatory
                        },
                        model: value
                    };
                }
                else if(type.toLowerCase() === 'select-multiple'){
                    let selectChoiceItems = convertStringArrayToArray(value);
                    return {
                        type: 'select2-multiple',
                        model: convertStringArrayToArray(value),
                        items: selectChoiceItems,
                        onRefresh: data => {
                            $timeout(() => {
                                if(data != "" && !selectChoiceItems.includes(data)) {
                                    selectChoiceItems.push(data.toUpperCase());
                                }
                            }, 1000);
                        }
                    }
                } 
                else if (type.toLowerCase() === 'number') {
                    return {type: 'numberInput', model: value};
                } 
                else if (type.toLowerCase() === 'boolean') {
                    return {
                        type: 'switch', labels: options || {true: 'On', false: 'Off'},
                        model: value, class:"edit-switch", style: 'width: 150px',
                        onChange: row=>{

                        },
                        tooltip
                    }
                }
                else if(type.toLowerCase() === 'select') {
                    return {
                        type: 'select2', 
                        model: value, 
                        items: row.valueList
                    }
                }
                return 'text';
            }
            function convertStringArrayToArray(value){
                const data = angular.copy(value);
                if(data.includes("[") && data.includes("]")){
                    let tmpData = data.slice(1, -1);
                    return tmpData.split(',');
                }
                return [];
            }
            function openConfigureTable() {
                const modalInstance = $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    windowClass: 'setting-modal',
                    templateUrl: '/templates/pages/carriers/additionals/serviceProfileSettingModal.html',
                    controller: function ($uibModalInstance, table) {
                        const vm = this;
                        vm.settingsConfTable = {};
                        vm.addSetting = addSetting;
                        vm.apply = apply;
                        vm.dismiss = dismiss;
                        function initTable() {
                            vm.settingsConfTable = {
                                config: {
                                    noPagination: true,
                                    noHeaders: false,
                                    noItemsView: true,
                                    noFooter: true,
                                    noExtraction: true,
                                    noTopOptions: true
                                },
                                headers: angular.copy(table.headers),
                                data: angular.copy(table.data),

                            };

                            vm.settingsConfTable.headers.splice(2, 0, {
                                label: 'TYPE',
                                viewName: 'type',
                                width: '20%'
                            });
                            vm.settingsConfTable.headers.pop();
                            vm.settingsConfTable.headers.push({
                                label: 'DELETE',
                                viewName: 'delete',
                                width: '20%'
                            });
                            angular.forEach(vm.settingsConfTable.data, function (data) {
                                data.name = {
                                    type: 'textInput',
                                    model: angular.copy(data.name)
                                };
                                data.description = {
                                    type: 'textInput',
                                    model: angular.copy(data.description)
                                };
                                data.type = {
                                    type: 'select2-multiple',
                                    items: typeOptions,
                                    model: angular.copy(data.type)
                                }
                                data.type = {
                                    type: 'select2',
                                    items: typeOptions,
                                    model: angular.copy(data.type)
                                };
                                data.delete = {
                                    type: 'button',
                                    buttons: [{
                                        text: 'Delete',
                                        class: 'btn btn-danger',
                                        action: (row) => {
                                            vm.settingsConfTable.data.splice(vm.settingsConfTable.data.indexOf(row), 1);
                                        }
                                    }]
                                }
                            });
                        }
                        function addSetting() {
                            vm.settingsConfTable.data.push({
                                name: {
                                    type: 'textInput',
                                    model: null
                                },
                                description: {
                                    type: 'textInput',
                                    model: null
                                },
                                type: {
                                    type: 'select2',
                                    items: typeOptions,
                                    model: 'Boolean'
                                },
                                type: {
                                    type: 'select2-multiple',
                                    items: typeOptions,
                                    model: 'Boolean'
                                },
                                delete: {
                                    type: 'button',
                                    buttons: [{
                                        text: 'Delete',
                                        class: 'btn btn-danger',
                                        action: (row) => {
                                            vm.settingsConfTable.data.splice(vm.settingsConfTable.data.indexOf(row), 1);
                                        }
                                    }]
                                }
                            })
                        }
                        function apply() {
                            $uibModalInstance.close(vm.settingsConfTable);
                        }
                        function dismiss() {
                            $uibModalInstance.dismiss();
                        }
                        (function () {
                            initTable();
                        })();
                    },
                    controllerAs: 'vm',
                    size: 'lg',
                    appendTo: $('body'),
                    resolve: {
                        table: function () {
                            return settingsTable;
                        }
                    }
                });

                modalInstance.result.then(function (data) {
                    settingsTable.data = [];
                    angular.forEach(data.data, function (row) {
                        row.name = row.name.model;
                        row.description = row.description.model;
                        row.type = row.type.model;
                        row.valueObj = getType(row.type, angular.getObjVal(row,'valueObj.model'), row.options, row);
                        settingsTable.data.push(row);
                    });
                }, function () {
                });
            }
            function getValueType(item, valueList = null) {
                if (item.valueType === 'number') {
                    return 'Number';
                }
                else if(checkIfStringValueIsAnArray(item.value)){
                    return 'select-multiple';
                } 
                else if (item.valueType === 'boolean') {
                    return 'Boolean';
                } 
                else {
                    if(valueList) {
                        if(valueList.length != 0) {
                            return 'select';
                        } 
                        return 'Text';
                    }
                    return 'Text';
                }
            }
            function checkIfStringValueIsAnArray(item){
               
                const data = angular.copy(item);

                if(!data) return false;

                if(data.includes("[") && data.includes("]")){
                    return true;
                }
                return false;
            }
            function parseValue(item) {
                if(!item)
                    return null;
                const val = (item).split('\"').join("");
                if(val === 'true')
                    return true;
                if(val === 'false')
                    return false;
                return val;
            }
            function getPayloadValue(item, type){
                if(type === 'Boolean'){
                    return item || item === "true" ? "true" : "false";
                }
                else if(type == 'select-multiple'){
                    return item ? `[${item.toString()}]` : '[]';
                }
                else if(type === 'Number'){
                    return item ? isNaN(parseFloat(item)) ? '0' : item.toString() : '0';
                }else if(type === 'Text'){
                    return item ? '\"' + item + '\"': '\"\"';
                }
                else if(type == 'select'){
                    return item;
                }
            }
            vm.buildSettings = () => {
                angular.forEach(profileSettings, function (setting) {
                    const settingCopy = angular.copy(setting);
                    settingCopy.isMandatory = function(row){
                        const requiredBy = profileSettings.filter((item,index)=>{
                            if(!angular.getObjVal(item, 'prerequisiteSettings.length')){
                                return false;
                            }
                            if(item.prerequisiteSettings.findIndex(name=>settingCopy.name.indexOf(name)) >= 0){
                                item.index = index;
                                return true;
                            }
                            return false;
                        });
                        const isRequiredByEnabled = requiredBy.find(item=>{
                            return angular.getObjVal(settingsTable.data[item.index], 'valueObj.model');
                        });
                        if(isRequiredByEnabled && row.name.indexOf(requiredLabel) < 0){
                            row.name += requiredLabel;
                        }else if(!settingCopy.mandatory && !isRequiredByEnabled){
                            row.name = row.name.split(requiredLabel).join('');
                        }
                        return settingCopy.mandatory || isRequiredByEnabled;
                    };

                    let settingFormat = {
                        name: `${settingCopy.name}${settingCopy.mandatory ? '<span class="text-red">*</span>' : ''}`,
                        description: settingCopy.description,
                        mandatory: settingCopy.mandatory,
                        value: parseValue(settingCopy.value),
                        type: getValueType(settingCopy, settingCopy.valueList),
                        valueObj: getType(getValueType(settingCopy, settingCopy.valueList), parseValue(settingCopy.value), settingCopy.options, settingCopy),
                    };
                    settingFormat.onRefresh = settingFormat.valueObj.onRefresh;
                    settingsTable.data.push(settingFormat);
                });
                return settingsTable;
            };
            vm.getSettingsPayload = () => {
                let settings = [];
                angular.forEach(settingsTable.data, function (setting) {
                    settings.push({
                        name: setting.name.split(requiredLabel)[0],
                        description: setting.description,
                        value: getPayloadValue(setting.valueObj.model, setting.type),
                        mandatory: setting.mandatory
                    });
                });
                return settings;
            };
            vm.setSubmitted = ()=>{
                angular.forEach(settingsTable.data, function (setting) {
                    if(setting.form){
                        setting.form.$setSubmitted();
                    }
                });
                const isValid = settingsTable.data.every(setting =>!angular.getObjVal(setting, 'form.$invalid'));
                vm.isValid = isValid;
                vm.isInvalid = !isValid;
            };
            vm.mapSettings = (carrierSettings, profileSettings) => {
                let options = [];
                angular.forEach(carrierSettings, carrierSetting => {
                    const matchSetting = profileSettings.find(profileSetting => profileSetting.name === carrierSetting.name);

                    options.push({
                        name: matchSetting ? matchSetting.name : carrierSetting.name,
                        description: matchSetting ? matchSetting.description : carrierSetting.description,
                        value: matchSetting ? matchSetting.value : carrierSetting.value,
                        options: carrierSetting && carrierSetting.option ? {
                            true: angular.getObjVal(carrierSetting, 'option.vtrue'),
                            false: angular.getObjVal(carrierSetting, 'option.vfalse')
                        } : null
                    });
                });

                return options;
            };
            vm.setErrors = (errors) => {
                // log error
            }
        };
    }
})();



// WEBPACK FOOTER //
// ./js/services/tables/CarrierSettingsTableService.js